var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4169_35767)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 24C12.5708 24 12.0609 23.788 11.637 23.3641C11.2123 22.9394 11 22.4292 11 21.8333V13.1667C11 12.5708 11.2123 12.0609 11.637 11.637C12.0609 11.2123 12.5708 11 13.1667 11H21.8333C22.4292 11 22.9394 11.2123 23.3641 11.637C23.788 12.0609 24 12.5708 24 13.1667V21.8333C24 22.4292 23.788 22.9394 23.3641 23.3641C22.9394 23.788 22.4292 24 21.8333 24H13.1667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4169_35767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerStop);
export default __webpack_public_path__ + "static/media/player-stop.7ebb3f14.svg";
export { ForwardRef as ReactComponent };